import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const getUser = createApiThunk<CoreUser, string>({
  action: 'user/get',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_USER(id),
})

export const getUserRounds = createApiThunk<UserRoundsResponse, UserRoundsPayload>({
  action: 'user/getRounds',
  method: REQUEST_METHOD.GET,
  formatUrl: (payload) => APIRoute.GET_USER_ROUNDS(payload.id),
  getParams: (payload) => payload.params,
})

export const updateUser = createApiThunk<CoreUser, UpdateUserPayload>({
  action: 'user/edit',
  method: REQUEST_METHOD.PUT,
  formatUrl: (payload) => APIRoute.PUT_UPDATE_USER(payload.id),
  getData: (payload) => payload.data,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const deleteUserImage = createApiThunk<void, DeleteUserImagePayload>({
  action: 'user/deleteImage',
  method: REQUEST_METHOD.DELETE,
  formatUrl: (payload) => APIRoute.DELETE_USER_IMAGE(payload.id, payload.imageType),
  getSuccessMessage: (payload) => payload.successMessage,
})

export const deleteUser = createApiThunk<void, DeleteUserPayload>({
  action: 'user/delete',
  method: REQUEST_METHOD.DELETE,
  formatUrl: (payload) => APIRoute.DELETE_USER(payload.id),
  getParams: (payload) => payload?.params,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const getUserPrivileges = createApiThunk<UserPrivilege[], number>({
  action: 'user/getPrivileges',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_USER_PRIVILEGES(id),
})

export const addNewPrivilege = createApiThunk<UserPrivilege, UserPrivilegePayload>({
  action: 'user/addPrivilege',
  method: REQUEST_METHOD.POST,
  formatUrl: (payload) => APIRoute.POST_USER_PRIVILEGE(payload.id),
  getData: (payload) => payload.data,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const updatePrivilege = createApiThunk<UserPrivilege, UserPrivilegePayload>({
  action: 'user/updatePrivilege',
  method: REQUEST_METHOD.PUT,
  formatUrl: (payload) => APIRoute.PUT_USER_PRIVILEGE(payload.id),
  getData: (payload) => payload.data,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const cancelPrivilege = createApiThunk<UserPrivilege, UserPrivilegePayload>({
  action: 'user/cancelPrivilege',
  method: REQUEST_METHOD.PUT,
  formatUrl: (payload) => APIRoute.PUT_USER_PRIVILEGE(payload.id),
  getData: (payload) => payload.data,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const getUserStats = createApiThunk<UserStatsResponse, number>({
  action: 'user/getStats',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_USER_STATS(id),
})

export const getUserExtra = createApiThunk<UserExtraResponse, number>({
  action: 'user/getExtra',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_USER_EXTRA(id),
})

export const getUserGameStats = createApiThunk<UserGameStatsResponse, number>({
  action: 'user/getGameStats',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_USER_GAME_STATS(id),
})

export const getUserLinkedAccounts = createApiThunk<UserLinkedAccountsResponse, number>({
  action: 'user/getLinkedAccounts',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_USER_LINKED_ACCOUNTS(id),
})
